import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useCurrentTheme } from "@/theming/useCurrentTheme";
import { ThemeType } from "@/theming/baseTheme";
import {QuickAction, QuickActionTile} from "@/components/common/QuickActionTile";

// Re-export QuickAction type for external use
export type {QuickAction};



interface QuickActionsGridProps {
    actions: QuickAction[];
    children?: React.ReactNode; // For additional components like DebugDataButton
}

export const QuickActionsGrid: React.FC<QuickActionsGridProps> = ({
                                                                      actions,
                                                                      children
                                                                  }) => {
    const { theme } = useCurrentTheme();
    const styles = createStyles(theme);

    return (
        <View style={styles.quickActions}>
            {actions.map((action) => (
                <QuickActionTile action={action} key={action.id} />
            ))}
            {children}
        </View>
    );
};

const createStyles = (theme: ThemeType) => StyleSheet.create({
    quickActions: {
        padding: theme.spacing.md,
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        gap: theme.spacing.sm
    },
});
